import { render } from "./PricePageList.vue?vue&type=template&id=4839a638&scoped=true&ts=true"
import script from "./PricePageList.vue?vue&type=script&lang=ts"
export * from "./PricePageList.vue?vue&type=script&lang=ts"

import "./PricePageList.vue?vue&type=style&index=0&id=4839a638&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4839a638"]])

export default __exports__